import { preview } from "common/constants";
export const sectionsWithoutFilters = [preview.sectionId];
export const analyticsCopilotWidgetsSectionId = "assistant_widgets";
